import React from 'react';
import ScrollBar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';

import Message from './Message';

export default class Messages extends React.Component {

    scrollBarRef = null;
    scrollElem = null;
    lastPosition = null;
    lastChatID = null;
    chats = null;
    totalChats = 0;
    reachedEnd = false

    componentDidMount() {
        this.scrollToPosition(this.scrollBarRef._ps.contentHeight);

        this.chats = document.querySelectorAll('div[class~=chats]');
        this.totalChats = this.chats.length;
    }

    componentDidUpdate(prevProps) {
        if (this.lastChatID) {
            const elemId = "chat-" + this.lastChatID;
            const elem = document.getElementById(elemId);
            
            if (typeof elem !== "undefined" && elem !== null) {
                const positionY = elem.offsetTop;

                if (this.lastPosition !== positionY) {
                    // DOM updated
                    this.chats = document.querySelectorAll('div[class~=chats]');

                    if (this.totalChats !== this.chats.length) {
                        this.totalChats = this.chats.length;
                        // console.log(this.totalChats, "messages");

                        // console.log("Scroll to:", positionY);
                        this.lastPosition = positionY;
                        this.scrollToPosition(positionY);
                        
                        // console.log("END", this.reachedEnd);
                        this.reachedEnd = true;
                    }
                }
            }
        }
        
        // Scroll to last sent message
        if (prevProps.sentMessage !== this.props.sentMessage) {
            this.scrollToPosition(this.scrollBarRef._ps.contentHeight);
            this.props.setSentMessage(false);
        }
    }

    scrollToPosition = (position) => {
		if (this.scrollBarRef && this.scrollElem) {
			this.scrollElem.scrollTop = position;
		}
	}

    handleYReachStart = () => {
        if (this.reachedEnd) {
            // console.log("[Prev] Last Chat ID:", this.lastChatID);
            this.lastChatID = this.chats.item(0).id.split("-")[1];
            // console.log("[Curr] Last Chat ID:", this.lastChatID);

            if (this.lastChatID > 1) {
                // Load more messages
                this.props.triggerLoadMore(this.props.group, this.lastChatID);
            }

            this.reachedEnd = false;
        }
    }

    render() {
        const { group, currentUser } = this.props;

        return (
            <ScrollBar
                id="messages"
                className="messages"
                ref={(ref) => { this.scrollBarRef = ref; }}
                containerRef={(ref) => { this.scrollElem = ref; }}
                onYReachStart={this.handleYReachStart}
                onYReachEnd={() => { this.reachedEnd = true; }}
            >
                {group.messages.map(message => (
                    <Message
                        key={message.id}
                        data={message}
                        currentUser={currentUser}
                    />
                ))}
            </ScrollBar>
        );
    }
}
